require('angular').module('wowApp.shop')
    .service('AddressService', ['$rootScope', 'Restangular', 'TrolleyService', 'StorePickerService', 'SettingsService', require('./address-service')])
    .factory('StateService', ['$rootScope', 'Restangular', require('./state-service')])
    .directive('wowBillingAddressEntry', ['AddressService', 'BwsNotificationService', 'ServerErrorFiller', '$rootScope', '$templateCache', 'CurrentUserService', 'StorePickerService', require('./billing-address/billing-address-entry-directive')])
    .directive('wowSavedAddress', ['AddressService', 'ShopperService', 'DeliveryService', '$rootScope', 'MoveFocus', require('./saved-address-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/address/index.js
 **/